import styled, { css } from 'styled-components';
import { Button } from 'antd';
import { getColor, getProp, ifProp, getColorByProp } from 'utils/helpers/styleHelpers';
import { Link } from 'react-router-dom';
import { ICustomButtonProps, ILinkWrapperProps } from './CustomButton.types';

export const SCustomButton = styled(Button)<ICustomButtonProps>`
  margin-bottom: ${getProp('marginBottom')}px;
  margin-top: ${getProp('marginTop')}px;

  ${({ uppercase }) =>
    uppercase === true &&
    css`
      text-transform: ${ifProp('uppercase', 'uppercase', 'none')};
    `}

  ${({ capitalize }) =>
    capitalize === true &&
    css`
      text-transform: ${ifProp('capitalize', 'capitalize', 'none')};
    `}

  ${({ type }) =>
    type === 'primary' &&
    css`
      color: ${getColorByProp('textColor')};
      background: ${getColorByProp('bgColor')};
      width: ${ifProp('fluid', '100%', 'auto')};
      border-color: ${getColorByProp('borderColor')};

      &:not([disabled]):hover {
        opacity: 0.8;
        color: ${getColorByProp('textColor')};
        border-color: ${getColorByProp('borderColor')};
        background-color: #3E4FE5;
      }

      &[disabled],
      &[disabled]:hover {
        color: ${getColor('cream')};
        background: ${getColor('charcoal60')};
      }
    `}

  ${({ type }) =>
    type === 'text' &&
    css`
      background: none;
      width: auto;
      height: auto;

      &:not([disabled]):hover {
        background: none;
      }

      &[disabled],
      &[disabled]:hover {
        background: ${getColor('charcoal60')};
      }
    `}

  ${({ type }) =>
    type === 'default' &&
    css`
      border: 2px solid ${getColor('blue')};
      background: transparent;
    `}

    ${({ page }) =>
    page === 'welcome' &&
    css`
      color: ${getColor('blue')};
      background-color: ${getColor('cream')};
      &:hover {
        color: ${getColor('cream')};
        background: transparent;
        border-color: ${getColor('cream')};
      }
    `}
  
  border-radius: 25px;

  display: flex;
  justify-content: center;
  align-items: center;

  ${({ buttonSize }) =>
    buttonSize === 'large' &&
    css`
      height: 52px;
      padding: 6px 18px;
      width: 100%;
    `}
  ${({ buttonSize }) =>
    buttonSize === 'middle' &&
    css`
      height: 39px;
      padding: 3px 40px;
      width: 387px;
    `}
  ${({ buttonSize }) =>
    buttonSize === 'small' &&
    css`
      height: 36px;
      padding: 1px 6px;
      width: 108px;
      font-size: 9px;
    `}
  ${({ buttonSize }) =>
    buttonSize === 'average' &&
    css`
      height: 36px;
      width: 243px;
    `}

  ${({ type }) =>
    type === 'default' &&
    css`
      border: 2px solid ${getColor('blue')};
      background: transparent;
    `}

  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;

    ${({ size }) =>
      size === 'large' &&
      css`
        font-size: 18px;
      `}
    ${({ size }) =>
      size === 'small' &&
      css`
        font-size: 14px;
      `}

    letter-spacing: 0.05rem;

    ${({ type }) =>
      type === 'default' &&
      css`
        color: ${getColor('blue')};
      `}
  }
`;

export const BtnLinkWrapper = styled(Link)<ILinkWrapperProps>`
  margin-bottom: ${getProp('marginBottom')}px;
  margin-top: ${getProp('marginTop')}px;
  width: ${ifProp('fluid', '100%', 'auto')};
`;
